export default __webpack_public_path__ + "static/media/placeholder-img-product-v2.8cce2a26.svg";